import { Prompt } from '../Prompt.component';

export const IdlePrompt: React.FC<{ onConfirm: () => void }> = (props) => {
  return (
    <Prompt
      type={'info'}
      mainText="Upływa czas bezczynności pracy, za chwilę nastąpi automatyczne wylogowanie"
      mainActionButtonText="Pracuję dalej"
      onConfirm={props.onConfirm}
    />
  );
};
